import React from 'react';

const ChampionCard = ({ name, imageUrl }) => (
  <div className="champion-card">
    <img src={imageUrl} alt={name} />
    <h2>{name}</h2>
  </div>
);

export default ChampionCard;